module.exports = __webpack_public_path__ + "img/home-educacao.02e7dc62.svg";